import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bar-graph',
  templateUrl: './bar-graph.component.html',
  styleUrls: ['./bar-graph.component.scss']
})
export class BarGraphComponent implements OnInit {
  columnOneValue: number;
  columnTwoValue: number;
  columnOnePercentage: number;
  columnTwoPercentage: number;

  @Input()
  graphTitle: string;

  @Input()
  columnOneName: string;

  @Input()
  columnTwoName: string;

  @Input()
  columnOneCount: number;

  @Input()
  columnTwoCount: number;

  @Input()
  redGreenTheme: boolean;

  @Input()
  showPercentages: boolean;

  @Input()
  tooltipText: string;

  @Input()
  leftTooltip: boolean;

  @Input()
  rightTooltip: boolean;

  @Input()
  centerTooltip: boolean;

  constructor() {}

  ngOnInit() {
    if (!this.leftTooltip && !this.rightTooltip && !this.centerTooltip) {
      this.centerTooltip = true;
    }
    this.columnOneValue = this.columnOneCount;
    this.columnTwoValue = this.columnTwoCount;
    this.columnOnePercentage = this.calculatePercentage(this.columnOneCount, this.columnTwoCount);
    this.columnTwoPercentage = this.calculatePercentage(this.columnTwoCount, this.columnOneCount);
  }

  calculatePercentage(num1: number, num2: number) {
    const sum = num1 + num2;
    return num1 === 0 ? 0 : num1 / sum;
  }
}
